import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { trustpilotProfileUrl, trustpilotEvaluateUrl } from '../../config/configTrustpilot';
import { ExternalLink } from '../../components';

import css from './TrustpilotSection.module.css';

// Trustpilot's own mark, drawn locally rather than loaded from their CDN.
// The wordmark is plain text so it inherits the marketplace font instead of
// pulling a webfont; only the star is theirs, in their brand green (#00b67a).
const TrustpilotLogo = ({ label }) => (
  <span className={css.logo} role="img" aria-label={label}>
    <svg
      className={css.logoStar}
      width="28"
      height="28"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M10 2.6l2.06 4.7L17 8.02l-3.6 3.5.92 5.02L10 14.18 5.68 16.54l.92-5.02L3 8.02l4.94-.72z" />
    </svg>
    <span aria-hidden="true">Trustpilot</span>
  </span>
);

/**
 * Invitation to review Perfumee on Trustpilot, rendered above the footer on the
 * pages Tara picked (see configTrustpilot).
 *
 * No TrustBox widget: on 2026-07-25 Trustpilot's API answered
 * "BusinessUnit does not have access to that trustbox" for every score-bearing
 * TrustBox on this account, leaving only the Review Collector, which is itself
 * just a button. A native button does the same job on brand, with no third-party
 * script, no iframe and no CSP surface. Re-add the widget only if Perfumee
 * subscribes to a paid plan and wants the live 4.6 / 5 score on screen.
 *
 * @component
 * @returns {JSX.Element|null} the section, or null when no profile URL is configured
 */
const TrustpilotSection = () => {
  const intl = useIntl();

  if (!trustpilotProfileUrl) {
    return null;
  }

  return (
    <section className={css.root}>
      <TrustpilotLogo label={intl.formatMessage({ id: 'TrustpilotSection.logoAlt' })} />
      <h2 className={css.title}>
        <FormattedMessage id="TrustpilotSection.title" />
      </h2>
      <p className={css.invitationText}>
        <FormattedMessage id="TrustpilotSection.text" />
      </p>
      {/* trustpilotEvaluateUrl opens Trustpilot's rating form straight away.
          The profile URL only lists the reviews, so it would cost a second
          click on "Écrire un avis" before anyone could type anything. */}
      <ExternalLink className={css.reviewButton} href={trustpilotEvaluateUrl}>
        <FormattedMessage id="TrustpilotSection.reviewButton" />
      </ExternalLink>
      <ExternalLink className={css.profileLink} href={trustpilotProfileUrl}>
        <FormattedMessage id="TrustpilotSection.profileLink" />
      </ExternalLink>
    </section>
  );
};

export default TrustpilotSection;
